//libs
import React from 'react';
import c from 'classnames';

//components
import { Box, DeprecatedIconButton, Stack, Tooltip } from '@lyearn/ui';

import { MarkType, MarkTypesEnum } from '../../plugins/SelectionMenu/types';
import ColorMenu from './components/ColorMenu';
//styles
import { iconButton } from './style';
//types
import type { MarksBarProps } from './types';

export const MarksBar: React.FC<MarksBarProps> = (props) => {
  let { marks, isMarkActive, view, getMarksAttrs, onMarkChangeAction } = props;

  const colorAttrs = getMarksAttrs(MarkTypesEnum.Color, view?.state);

  return (
    <Stack alignItems="center" className="rounded-8 bg-bg-primary ps-4">
      {marks.map((mark: MarkType, key: number) => {
        if (mark.name === MarkTypesEnum.Color) {
          return (
            <ColorMenu
              key={key}
              selectedBackgroundColor={colorAttrs ? colorAttrs.backgroundColor : 'transparent'}
              selectedColor={colorAttrs ? colorAttrs.color : '#000000'}
              onMarkChangeAction={onMarkChangeAction}
            />
          );
        }

        if (mark?.break) return <Box key={key} className="m-2 h-24 w-1 bg-border" />;

        if (mark.name === MarkTypesEnum.Custom) {
          return mark.CustomComponent ? <mark.CustomComponent editorView={view} /> : null;
        }

        return (
          <Tooltip key={key} title={mark.title || ''}>
            <Box component="span">
              <DeprecatedIconButton
                className={iconButton}
                data-id={mark.title}
                variant="ghost"
                onClick={() => onMarkChangeAction({ type: mark.name })}>
                <mark.icon
                  className={c(
                    'top-3 absolute fill-current',
                    !mark?.list && mark.name != 'blockquote' && isMarkActive(mark.name, view?.state)
                      ? 'text-icon-active'
                      : 'text-icon-primary',
                  )}
                />
              </DeprecatedIconButton>
            </Box>
          </Tooltip>
        );
      })}
    </Stack>
  );
};

export default MarksBar;
